<template>
    <div class="wt-leader-tab">
        <div class="wt-leader-list-header mb-3 d-flex align-items-center justify-content-between" v-if="!$route.query.leaderboard">
            <ul class="d-flex align-items-center">
                <li v-for="item in leaders" :class="{ 'active':item == tab }" @click="tab = item">{{item}}</li>
            </ul>
            <div class="view-all-btn">
                <router-link :to="{'query':{'leaderboard':filterID}}" class="btn appButton bg-transparent justify-content-center h-36 mx-auto">{{$t('view_all')}}</router-link>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-12">
                <div class="backBtn mb-3 d-flex justify-content-between border-bottom p-2">
                    <a href="javascript:void(0)" class="d-inline-flex align-items-center white f-16" @click.prevent="$router.back()">                   
                        <span class="d-flex linkBG align-items-center justify-content-center mr-2">
                            <img src="../../../../static/website/images/arrow-left.svg" >
                        </span>
                        {{$t('back')}}
                    </a>
                    <div>
                        <a href="javascript:void(0)" class="btn appButton linkBG mx-auto justify-content-center mx-auto h-36 radius-50" @click.prevent="showFilterModal = true">{{$t('filter')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <LeadersFilter v-if="showFilterModal" @close="showFilterModal = false" :filter="filter" @submitFilter="submitFilter" :rememberFilter="rememberFilter"></LeadersFilter>
        <div class="wt-leader-list-main my-2 wt-scroll pr-2">
            <!-- {{ followersSetting }} -->
            <app-loader v-if="pageLoader"/>
            <div class="wt-leader-list ">
                <div class="wt-leader-list-card" v-for="item in leaderListByTab"
                    @click="$router.push( {path : '/leader-detail', query : { 'id' : multiply9(item.trader.providerId), 't' : entrykey(item.trader.timeframeStats,0) } } )"
                >
                    <!-- @click="$router.push('/leader-detail?id='+multiply9(item.trader.providerId))+'&t='+entrykey(item.trader.timeframeStats,0)" -->
                    <div class="wt-leader-list-card-header d-flex align-items-center justify-content-between">
                        <div class="wt-leader-list-card-profile">
                            <div class="d-flex align-items-center">
                                <router-link :to="{path : '/leader-detail', query : { 'id' : multiply9(item.trader.providerId), 't' : entrykey(item.trader.timeframeStats,0) } }" @click.prevent>
                                    <img
                                        class="wt-dashborad-leader-card-profileImg mr-2"
                                        :src="item.trader.profile.avatarURL" height="51" style="border-radius: 50%;"
                                    > 
                                </router-link>
                                <router-link :to="{path : '/leader-detail', query : { 'id' : multiply9(item.trader.providerId), 't' : entrykey(item.trader.timeframeStats,0) } }" @click.prevent>
                                    <span class="wt-leader-card-name f-14" style="color: var(--btn-color-white);">{{item.trader.profile.name || ''}}</span>                                                                                                   
                                    <span class="white opacity-7 mt-n1  d-flex align-items-center">
                                        {{$t('copiers')}}: {{ item.trader.overallStats.followers || 0 }}
                                    </span>                                                                                                   
                                </router-link>
                            </div>
                        </div>
                        <div class="py-2">
                            <a href="#" class="follow-btn btn white f-14 d-flex align-items-center justify-content-center px-3"
                                @click.stop.prevent="followId = item.trader.providerId; followName = item.trader.profile.name;"
                                :class="{'greenBG' : isFollowing(item.trader.providerId)}"
                            >{{isFollowing(item.trader.providerId)?'Following':'Follow Strategy'}}</a>
                        </div>
                    </div>
                    <div class="wt-leader-list-card-footer my-4">
                        <span class="f-22 link-color ml-1"> <strong> {{ getNumberWithSign(entry(item.trader.timeframeStats,0).annualizedRorBasedRoi || 0) }}%</strong></span>
                        <span class="f-12 ml-2 opacity-7">{{$t('roi')}}</span>
                    </div>
                    <div class="wt-leader-list-card-footer d-flex align-items-center justify-content-between mt-4">
                        <div class="win">
                            <span class="white d-block f-18">{{ numberFormating(entry(item.trader.timeframeStats,1).winTrades || 0) }}%</span>
                            <span class="d-inline-block f-12 mt-2 opacity-7">{{$t('win_rate')}}</span>
                        </div>
                        <div class="risk text-center">
                            <router-link :to="'/leader-detail?id='+multiply9(item.trader.providerId)" @click.prevent>                                    
                                <span class="wt-dashborad-chart-right-card-badge text-center d-inline-flex align-items-center justify-content-center" :class="leadersFilter.riskClass[entry(item.trader.timeframeStats,0).timeFrameRisk] || 'green'">
                                    <span class="f-14 ">{{ entry(item.trader.timeframeStats,0).timeFrameRisk || '' }}</span>
                                </span>                                                                                                   
                                <div class="white f-12 mt-2 opacity-7">{{$t('risk')}}</div>
                            </router-link>
                        </div>
                        <div class="profit">
                            <div class="d-flex flex-column mt-2 text-right"> 
                                <span class="f-18 white ml-1">
                                    {{item.trader.profile.baseCurrencySymbol || ''}}{{ numberFormating(entry(item.trader.timeframeStats,0).totalProfitMoney || 0) }}
                                </span>
                                <span class="d-block f-12 mt-2 opacity-7">{{$t('total_Profit')}}</span>                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nodataFound position-relative" v-if="!pageLoader && leaderListByTab.length == 0">
                    <div class="boxedNodata d-flex justify-content-center">
                        <div class="noDataPic">
                            <img src="../../../../static/website/images/no-data.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row btn-row mt-4" v-if=" loadmore && !pageLoader && leaderListByTab.length &&(filter.sortBy != '' || filter.instrumentTypes.length != 0 || filter.timeFrame != '')"> -->
            <div class="row btn-row mt-4" v-if=" loadmore && !pageLoader && leaderListByTab.length && $route.query.leaderboard">
                <div class="col-lg-12">
                    <div class="backBtn mb-3 d-flex justify-content-center">
                        <div>
                            <a href="javascript:void(0)" class="btn appButton linkBG mx-auto justify-content-center mx-auto" @click.prevent="filter.page += 1; submitFilter();">{{$t('load_more')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-follow v-if="followId" :followId="followId" :followName="followName" @close="followId = ''" @backToDashboard="backToDashboard"></app-follow>
    </div>
</template>

<script>
    import AppFollow from './follow.vue';
    import LeadersFilter from './filter.vue';
    import { commonAllmixins } from "@/plugins/commonAll";
    export default{
        mixins: [commonAllmixins],
        emits:['updateTab'],
        data(){
            return{
                pageLoader : false,
                followId : '',
                followName : '',
                showFilterModal : false,
                // tab: "Under $1000",
                tab: "Top Performing",
                /*leaders:[
                    "Under $1000",
                    "Top Performing",
                    "Top Performing 1 Year",
                    "Top Performing 2 Years",
                    "Amount Copying",
                ],*/
                filter : {
                    "size": 15,
                    "page": 0,
                    "sortAsc": false,
                    "bringDetailedChart": false,
                    "sortBy": '',
                    "instrumentTypes":[],
                    "timeFrame": ''
                },
                rememberFilter : false,
                loadmore : true,
            }
        },
        components:{ AppFollow, LeadersFilter },
        computed:{
            leaders(){
                return this.leadersList.map(v=>v.name) || []
            },
            leaderListByTab(){
                if(!this.$route.query.leaderboard){
                    return (this.leadersList.find(item => item.name == this.tab) || {}).result || [];
                }
                /*else if(this.filter.sortBy == '' && this.filter.instrumentTypes.length == 0 && this.filter.timeFrame == ''){
                    return (this.leadersList.find(item => item.filterId == this.$route.query.leaderboard) || {}).result || [];
                }*/else{
                    // console.log(this.allLeadersList)
                    return this.allLeadersList
                }
            },
            leaderListByFilterId(){
                // console.log(data)
                return data;
            },
            filterID(){
                return (this.leadersList.find(item => item.name == this.tab) || {}).filterId || '';
            }
        },
        methods:{
            backToDashboard(){
                if(this.$route.query.leaderboard){
                    this.$router.push({})
                }
                this.$emit('updateTab',1)
            },
            back(){
                this.$router.back();
                this.filter.sortBy = '';
                this.filter.instrumentTypes = [];
                this.filter.timeFrame = '';
            },
            submitFilter(val){
                if(val){
                    function arraysEqual(arr1, arr2) {
                        if (arr1.length !== arr2.length) return false;
                        for (let i = 0; i < arr1.length; i++) {
                            if (arr1[i] !== arr2[i]) return false;
                        }
                        return true;
                    }
                    if(this.filter.sortBy != val.sortBy){
                        this.filter.sortBy = val.sortBy;
                        this.filter.page = 0;
                        this.loadmore = true;
                    }
                    if(!arraysEqual(this.filter.instrumentTypes,val.instrumentTypes)){
                        this.filter.instrumentTypes = val.instrumentTypes;
                        this.filter.page = 0;
                        this.loadmore = true;
                    }
                    if(this.filter.timeFrame != val.timeFrame){
                        this.filter.timeFrame = val.timeFrame;
                        this.filter.page = 0;
                        this.loadmore = true;
                    }
                }
                /*/if((this.filter.sortBy == '' && this.filter.instrumentTypes.length == 0 && this.filter.timeFrame == '')){
                    this.filter.page = 0;
                    this.loadmore = true;
                    return;
                }*/
                let filter = {
                    "size": this.filter.size,
                    "page": this.filter.page,
                    "sortAsc": this.filter.sortAsc,
                    "bringDetailedChart": this.filter.bringDetailedChart,
                    "sortBy": this.filter.sortBy?this.filter.sortBy:undefined,
                    "instrumentTypes":this.filter.instrumentTypes.length?this.filter.instrumentTypes:undefined,
                    "timeFrame": this.filter.timeFrame?this.filter.timeFrame:undefined
                }
                this._runGetAllLeadersList({ globalParams: filter, localParams: { parameter: this } });
            },
            entry(val,isLast){
                const entries = Object.entries(val);
                if(isLast){
                    return entries[entries.length - 1][1];
                }else{
                    return entries[0][1];
                }
            },
            entrykey(val,isLast){
                const entries = Object.entries(val);
                if(isLast){
                    return entries[entries.length - 1][1];
                }else{
                    return entries[0][0];
                }
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leaders.vue